import { useState, useEffect, useCallback, useRef } from "react";
import "../vendor/vendorList.css";
import "../common/Util.css";
import { ReactComponent as SearchIc } from "../../assets/svg/search.svg";
import { ReactComponent as ImportIc } from "../../assets/svg/import_ic.svg";
import { ReactComponent as AddIc } from "../../assets/svg/add_icon.svg";
import { ReactComponent as DownArrow } from "../../assets/svg/down_arror.svg";
import { ReactComponent as DownArrowIc } from "../../assets/svg/down_arrow_ics.svg";
import { ReactComponent as ThreeDotIC } from "../../assets/svg/three-dot-ic.svg";
import { ReactComponent as RarIc } from "../../assets/svg/rar_ic.svg";
import { ReactComponent as LarIc } from "../../assets/svg/lar_ic.svg";
import profileIc from "../../assets/png/profile-ic.png";
import { ReactComponent as LoadingIc } from "../../assets/svg/loading_icon.svg";
import { Dropdown, Toast, ToastContainer, Button, Modal, Form } from "react-bootstrap";
import { apiCall } from "../../services/api-service.js";
import SearchableDropdown from "../common/commonDropDown";
import StaticPortalDropdown from "../common/commonPortalStaticDropdown";
import ReactPaginate from "react-paginate";
import LoaderModal from "../common/loader";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../common/deleteModel";
import DateRangePicker from "../common/dateRange";
import "react-datepicker/dist/react-datepicker.css";
import { deleteTransApi, downloadTemplateExcelApi, getPaymentApi, getTransactionListApi, updateStageApi, uploadExcelApi } from "./transaction_api";
import { format } from "date-fns";
import { Sidebar } from "../common/Sidebar";
import { Navbar } from "../common/Navbar";
import { ReactComponent as ListView } from "../../assets/svg/list_view_ic.svg";
import { ReactComponent as SelectGrid } from "../../assets/svg/seelct_grid_ic.svg";
import { ReactComponent as SelectList } from "../../assets/svg/select_list_ic.svg";
import { ReactComponent as EmailView } from "../../assets/svg/email_view_ic.svg";
import { ReactComponent as EditIc } from "../../assets/svg/edit_ic.svg";
import { ReactComponent as DeleteIc } from "../../assets/svg/delete_ic.svg";

import { ReactComponent as DownloadIc } from "../../assets/svg/download_Ics.svg";
import { useGlobal } from "../../GlobalContext";
import numberFormat from "../common/number-format";
import ImportTemplateButtons from "../common/import-download-button";
import { downloadBase64File } from "../../services/file-download-service";
import ProfileImageModal from "../common/common-preview";
function TransactionListingPage() {
  // location
  const navigate = useNavigate();
  // Api Url
  const apiUrl = process.env.REACT_APP_API_URL;
  const [importLoading, setImportLoading] = useState(false);
  const [templateLoading, setTemplateLoading] = useState(false);

  // variable initial
  const iconStyle = { width: "16px", height: "16px" };
  const savedFilters = JSON.parse(sessionStorage.getItem("transaction_filters") || "{}");

  const [search, setSearch] = useState(savedFilters.search || "");
  const [selectedSortby, setSelectedSortBy] = useState(savedFilters.selectedSortby || {
    value: "created desc",
    label: "Date created (Newest)",
  });
  const [paymentSelect, setPaymentSelect] = useState(savedFilters.paymentSelect || {
    value: "",
    label: "All",
  });
  const [statusSelect, setStatusSelect] = useState(savedFilters.statusSelect || {
    value: "",
    label: "All",
  });
  const [isUploading, setIsUploading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [vendorSelect, setVendorSelect] = useState(savedFilters.vendorSelect || null);
  const [projectSelect, setProjectSelect] = useState(savedFilters.projectSelect || null);
  const [startDateSave, setStartDateSave] = useState(savedFilters.startDateSave || null);
  const [endDateSave, setEndDateSave] = useState(savedFilters.endDateSave || null);

  const [active, setActive] = useState("list");
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(savedFilters.hasOwnProperty('itemOffset') ? savedFilters.itemOffset : 0);
  const [deleteId, setDeleteId] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(savedFilters.hasOwnProperty('itemsPerPage') ? savedFilters.itemsPerPage : 10);
  const [paymnetOption, setPaymentOption] = useState([]);
  const [selectedApprovalFilter, setSelectedApprovalFilter] = useState(savedFilters.selectedApprovalFilter || {
    value: "",
    label: "Show all",
  });
  const [pendingApprovalsCount, setPendingApprovalsCount] = useState(0);
  const [isApprovalDropdownOpen, setIsApprovalDropdownOpen] = useState(false);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [approvalAction, setApprovalAction] = useState("");
  const [approvalTransId, setApprovalTransId] = useState(null);
  const [approvalComments, setApprovalComments] = useState("");
  const [approvalCommentsMandatory, setApprovalCommentsMandatory] = useState(false);

  useEffect(() => {
    const filters = {
      search,
      selectedSortby,
      paymentSelect,
      statusSelect,
      vendorSelect,
      projectSelect,
      startDateSave,
      endDateSave,
      itemOffset,
      itemsPerPage,
      selectedApprovalFilter,
    };
    sessionStorage.setItem("transaction_filters", JSON.stringify(filters));
  }, [search, selectedSortby, paymentSelect, statusSelect, vendorSelect, projectSelect, startDateSave, endDateSave, itemOffset, itemsPerPage, selectedApprovalFilter]);

  const [stageListOption, setListStageOption] = useState([]);
  const [sortByOption, setSortByOption] = useState([
    {
      value: "created asc",
      label: "Date created (Oldest)",
    },
    { value: "created desc", label: "Date created (Newest)" },
    { value: "updated asc", label: "Date updated (Oldest)" },
    { value: "updated desc", label: "Date updated (Newest)" },
  ]);
  const [statusOption, setStatusOption] = useState([
    { value: "", label: "All" },
    { value: "Partially Paid", label: "Partially Paid" },
    { value: "Pending", label: "Pending" },
    { value: "Paid", label: "Paid" },
  ]);
  const [transactList, setTransactList] = useState([]);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  // handle
  const handleSelectVendor = (option) => {
    console.log("Selected option:", option);
    setVendorSelect(option);
    setItemOffset(0);
  };
  const handleSelectProject = (option) => {
    console.log("Selected option:", option);
    setProjectSelect(option);
    setItemOffset(0);
  };
  const { rolePermissionList, userType } = useGlobal();
  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex((element) => element["name"] === menuName && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
  }
  const handleClearVendor = () => {
    setVendorSelect(null);
    setItemOffset(0);
  };
  const handleClearProject = () => {
    setProjectSelect(null);
    setItemOffset(0);
  };

  const handlePageClick = useCallback((event) => {
    setItemOffset(event.selected);
  }, []);

  const handleDateChange = ({ start, end }) => {
    console.log("Selected Start:", start);
    console.log("Selected End:", end);

    const formattedStart = start ? format(start, "yyyy-MM-dd") : null;
    const formattedEnd = end ? format(end, "yyyy-MM-dd") : null;

    console.log("Formatted Start:", formattedStart);
    console.log("Formatted End:", formattedEnd);

    setStartDateSave(formattedStart);
    setEndDateSave(formattedEnd);
    setItemOffset(0);
  };

  // download

  const fileInputRef = useRef(null);
  const handleFileClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    } else {
      console.error("File input is not initialized.");
    }
  };
  const handleFileChange = async (event, responseMsg) => {
    const file = event.target.files?.[0];

    if (!file) {
      alert("Please select a valid excel file.");
      return;
    }

    setImportLoading(true);

    try {
      const base64String = await new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject("File reading failed");

        reader.readAsDataURL(file);
      });

      // ✅ WAIT for upload to finish
      await uploadExcel(base64String, responseMsg);
    } catch (error) {
      console.error(error);
      alert("Failed to import file");
    } finally {
      // ✅ Always reset input & loader
      if (event.target) {
        event.target.value = "";
      }
      setImportLoading(false);
    }
  };

  const uploadExcel = async (base64String) => {
    try {
      const response = await uploadExcelApi("transaction_upload", base64String);
      if (response.status === 200) {
        if (response.data.success === true) {
          const base64String = response.data.base64;
          const fileName = response.data.file_name ?? `Transaction_${new Date().getTime()}.xlsx`;

          downloadBase64File(base64String, fileName);
          getTransactionList();
          setSnackbarMessage(response.data.message);
          setSnackbarStatus(response.data.success);
          handleSnackbarShow();
          return;
        }
      }
      setSnackbarMessage(response.data.message);
      setSnackbarStatus(response.data.success);
      handleSnackbarShow();
      if (response.data.base64 != null && response.data.base64 !== "") {
        const base64String = response.data.base64;
        const fileName = `Transaction_${new Date().getTime()}.xlsx`;
        downloadBase64File(base64String, fileName);
      }
    } catch (error) {
      console.error("Error uploading Excel:", error);
      setSnackbarMessage("Error uploading file");
      setSnackbarStatus(false);
      handleSnackbarShow();
    }
  };
  const downloadTemplateExcel = async () => {
    if (templateLoading) return;
    setTemplateLoading(true); // ✅ start loader

    try {
      const response = await downloadTemplateExcelApi("Transaction");

      if (response?.status === 200 && response?.data?.success) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(true);
        handleSnackbarShow();

        const base64String = response.data.base64;
        const fileName = `Transaction_template_${Date.now()}.xlsx`;

        // ✅ Download file
        downloadBase64File(base64String, fileName);
      } else {
        throw new Error("Template download failed");
      }
    } catch (error) {
      console.error(error);

      setSnackbarMessage(error?.response?.data?.message || "Failed to download template");
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setTemplateLoading(false); // 🔁 ALWAYS stop loader
    }
  };

  // const downloadBase64File = (base64String) => {
  //   const binary = atob(base64String);
  //   const array = [];

  //   for (let i = 0; i < binary.length; i++) {
  //     array.push(binary.charCodeAt(i));
  //   }

  //   const blob = new Blob([new Uint8Array(array)], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });

  //   const link = document.createElement("a");
  //   link.href = URL.createObjectURL(blob);
  //   link.download = "Transaction_" + new Date().getTime() + ".xlsx";
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };
  // useEffect

  useEffect(() => {
    getPaymentStages();
  }, []);
  useEffect(() => {
    // if (isFirstRender.current) {
    //   isFirstRender.current = false; // skip first run
    //   return;
    // }
    getTransactionList();
  }, [itemsPerPage, itemOffset, search, selectedSortby, paymentSelect, vendorSelect, projectSelect, statusSelect, startDateSave, endDateSave, selectedApprovalFilter]);

  useEffect(() => {
    if (deleteId !== null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);
  const handleApprovalActionClick = (transId, action, isCommentsMandatory) => {
    setApprovalTransId(transId);
    setApprovalAction(action);
    setApprovalComments("");
    setApprovalCommentsMandatory(isCommentsMandatory || action === "REJECT");
    setShowApprovalModal(true);
  };

  const handleApprovalAction = async () => {
    if (approvalCommentsMandatory && !approvalComments.trim()) {
      alert("Comment is required.");
      return;
    }

    setShowApprovalModal(false);
    setIsLoading(true);
    try {
      const response = await apiCall("post", "approval/action", {
        document_id: approvalTransId,
        document_type: "transaction",
        action: approvalAction,
        comments: approvalComments,
      });
      if (response.data?.success) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(true);
        handleSnackbarShow();
        getTransactionList();
      } else {
        setSnackbarMessage(response.data?.message || "Action failed");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (e) {
      console.error(e);
      setSnackbarMessage("An error occurred.");
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setIsLoading(false);
    }
  };

  // Api
  const getPaymentStages = async () => {
    try {
      const response = await getPaymentApi();
      if (response.data.success === true) {
        setPaymentOption([{ value: "", label: "All" }, ...response.data.suggestionlist]);

        setListStageOption(response.data.suggestionlist);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const updateStage = async (id, value) => {
    setIsLoading(true);
    const bodyData = {
      stage: value,
    };
    try {
      const response = await updateStageApi(id, bodyData);
      console.log("response....", response);
      if (response.data.success === true) {
        getTransactionList();
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const deleteTrans = async () => {
    // setIsLoading(true);
    try {
      const response = await deleteTransApi(deleteId);
      console.log("response....", response);
      if (response.data.success === true) {
        getTransactionList();
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        setDeleteId(null);
        setIsOpenDelete(false);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const getTransactionList = async () => {
    setIsLoading(true);
    const [field, dir] = selectedSortby?.value?.split(" ") || ["Created", "desc"];
    const param = {
      limit: itemsPerPage,
      skip: itemOffset * itemsPerPage,
      search: search,
      payment_type_id: paymentSelect?.value ?? "",
      vendor_id: vendorSelect?.value ?? "",
      project_id: projectSelect?.value ?? "",
      status: statusSelect?.value ?? "",
      from_date: startDateSave,
      to_date: endDateSave,
      sort_field: field,
      sort_dir: dir,
      my_approvals: selectedApprovalFilter?.value ?? "",
    };
    try {
      const response = await getTransactionListApi(param);
      if (response.data.success === true) {
        setTotalCount(response.data.total_rec ?? 0);
        setPageCount(response.data.total_pgs ?? 0);
        setTransactList((Array.isArray(response.data.transactions) ? response.data.transactions : []).filter(Boolean));
        setPendingApprovalsCount(Number(response.data.pending_approvals_count) || 0);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState("");
  return (
    <>
      <ProfileImageModal show={showProfilePopup} onClose={() => setShowProfilePopup(false)} imageUrl={selectedProfile} />
      <LoaderModal show={isLoading} />
      <style>
        {`
          #dropdown-approval-filter::after {
            display: none !important;
          }
          .my-approvals-toggle-btn {
            background-color: #F1F0FF !important;
            border: none !important;
            border-radius: 100px !important;
            padding: 8px 24px !important;
            height: 40px !important;
            color: #4F46E5 !important;
            transition: all 0.2s ease-in-out !important;
            display: flex !important;
            align-items: center !important;
            justify-content: space-between !important;
            gap: 8px !important;
            box-shadow: none !important;
          }
          .my-approvals-toggle-btn:hover {
            background-color: #E8E6FF !important;
          }
          .my-approvals-toggle-btn:focus, .my-approvals-toggle-btn.show, .my-approvals-toggle-btn:focus-within {
            background-color: #E8E6FF !important;
            box-shadow: 0 0 0 0.2rem rgba(108, 92, 231, 0.15) !important;
          }
          .my-approvals-toggle-btn .dropdown-text {
            color: #4F46E5 !important;
            font-size: 14px !important;
            font-weight: 500 !important;
          }
          .view-toggle-container {
            height: 40px !important;
            background-color: #F1F3F6 !important;
            border-radius: 100px !important;
            padding: 4px !important;
            gap: 4px !important;
            align-items: center !important;
            justify-content: center !important;
            display: inline-flex !important;
          }
          .view-toggle-item {
            width: 32px !important;
            height: 32px !important;
            border-radius: 50% !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            cursor: pointer !important;
            transition: all 0.2s ease-in-out !important;
            border: none !important;
            background-color: transparent !important;
          }
          .view-toggle-item.active-item {
            background-color: #FFFFFF !important;
            box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08) !important;
            border: 0.8px solid #EBEBEB !important;
          }
        `}
      </style>
      <DeleteModal title={"transaction"} isOpen={isOpenDelete} onClose={() => setIsOpenDelete(false)} onDelete={deleteTrans} />
      <div className="d-flex">
        {/* Sidebar */}
        <Sidebar currentfile="Transactions" />

        {/* Main Content */}
        <div className="rounded-4 flex-grow-1  ">
          {" "}
          <Navbar pageTitle="Transactions" />
          <div className="bg-half-white p-2">
            <div className="bg-white rounded-4 p-4">
              {/* First Row */}
              <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-3">
                {/* Left: Heading & Search */}
                <div className="d-flex align-items-center flex-wrap gap-3">
                  <div className="my-heading fs-24 fw-600" style={{ whiteSpace: "nowrap" }}>Transactions -{totalCount}</div>

                  {/* Search */}
                  <div className="search-wrapper d-flex align-items-center gap-2 px-3 py-2">
                    <SearchIc />
                    <input type="text" placeholder="Search" className="border-0 outline-0 rounded-3 fs-14 fw-500 textcolor" value={search || ""} onChange={(e) => { setSearch(e.target.value); setItemOffset(0); }} />
                  </div>
                </div>

                {/* Right: Controls */}
                <div className="d-flex align-items-center flex-wrap gap-3">
                  {/* Add New Vendor */}
                  {checkPermission("Transactions", "create_permission") && (
                    <div
                      className="cursor-pointer my-box d-flex align-items-center justify-content-center gap-2 px-3"
                      onClick={() => navigate("/transaction/create")}
                      style={{
                        height: "40px", // Adjust button height if needed
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <AddIc style={{ width: "16px", height: "16px" }} /> {/* ✅ Smaller Icon */}
                      </div>

                      <div
                        className="fs-12 fw-600" // ✅ Reduced text size
                        style={{ lineHeight: "16px" }}
                      >
                        New transaction
                      </div>
                    </div>
                  )}

                  <ImportTemplateButtons ImportIcon={ImportIc} DownloadIcon={DownloadIc} templateLoading={templateLoading} importLoading={importLoading} onImport={(e) => handleFileChange(e)} onDownloadTemplate={downloadTemplateExcel} />
                </div>
              </div>

              {/* Second Row */}
              <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
                <div className="d-flex justify-content-start align-items-center gap-2 flex-wrap">
                  <div style={{ flexShrink: 0, width: "160px" }}>
                    <StaticPortalDropdown
                      placeholder="Sort by"
                      value={selectedSortby}
                      options={sortByOption}
                      textMaxWidth="65px"
                      onSelect={(option) => {
                        setSelectedSortBy(option);
                        setItemOffset(0);
                      }}
                    />
                  </div>
                  <div style={{ flexShrink: 0, width:'160px' }}>
                    <StaticPortalDropdown
                      placeholder="Payment type"
                      value={paymentSelect}
                      options={paymnetOption}
                      textMaxWidth="80px"
                      onSelect={(option) => {
                        setPaymentSelect(option);
                        setItemOffset(0);
                      }}
                    />
                  </div>
                  <div style={{ flexShrink: 0 }}>
                    <StaticPortalDropdown
                      placeholder="Status"
                      value={statusSelect}
                      options={statusOption}
                      onSelect={(option) => {
                        setStatusSelect(option);
                        setItemOffset(0);
                      }}
                    />
                  </div>
                  <div style={{ flexShrink: 0 }}>
                    <SearchableDropdown apiUrl={`${apiUrl}get_vendor`} placeholder="Vendor" value={vendorSelect} onSelect={handleSelectVendor} handleClear={handleClearVendor} />
                  </div>

                  <div
                    className="d-flex align-items-center px-2"
                    style={{
                      borderRadius: "12px",
                      border: "1px solid #EBEBEB",
                      height: "38px",
                      backgroundColor: "white",
                      flexShrink: 0,
                      width: "165px",
                    }}
                  >
                    <span className="fs-12 fw-400 textGrey me-1" style={{ whiteSpace: "nowrap" }}>Date :</span>
                    <span className="dropdown-text1 textPurple" style={{ whiteSpace: "nowrap" }}>
                      {" "}
                      <DateRangePicker onChange={handleDateChange} />
                    </span>
                  </div>
                </div>
                <div className="d-flex align-items-center flex-wrap gap-3" style={{ marginLeft: "auto" }}>
                  <div style={{ flexShrink: 0 }}>
                    <Dropdown onToggle={(isOpen) => setIsApprovalDropdownOpen(isOpen)}>
                      <Dropdown.Toggle
                        variant="light"
                        id="dropdown-approval-filter"
                        className="d-flex align-items-center justify-content-between filter-btn-highlight my-approvals-toggle-btn"
                      >
                        <span className="dropdown-text">
                          {selectedApprovalFilter.label}
                        </span>

                        {pendingApprovalsCount > 0 && !isApprovalDropdownOpen && (
                          <span
                            className="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center"
                            style={{
                              fontSize: "10px",
                              width: "16px",
                              height: "16px",
                              fontWeight: "700",
                            }}
                          >
                            {pendingApprovalsCount}
                          </span>
                        )}

                        <span className="dropdown-toggle-arrow textPurple ps-1">
                          <DownArrow />
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        className="custom-dropdown-menu"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <Dropdown.Item
                          className="custom-dropdown-item"
                          onClick={() => {
                            setSelectedApprovalFilter({
                              value: "",
                              label: "Show all",
                            });
                            setItemOffset(0);
                          }}
                          active={selectedApprovalFilter.value === ""}
                        >
                          Show all
                        </Dropdown.Item>
                        <Dropdown.Item
                          className="custom-dropdown-item d-flex align-items-center justify-content-between"
                          onClick={() => {
                            setSelectedApprovalFilter({
                              value: "true",
                              label: "My approvals",
                            });
                            setItemOffset(0);
                          }}
                          active={selectedApprovalFilter.value === "true"}
                          style={{ gap: "10px" }}
                        >
                          <span>My approvals</span>
                          {pendingApprovalsCount > 0 && (
                            <span
                              className="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center"
                              style={{
                                fontSize: "10px",
                                width: "16px",
                                height: "16px",
                                fontWeight: "700",
                              }}
                            >
                              {pendingApprovalsCount}
                            </span>
                          )}
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div className="view-toggle-container">
                    <div
                      onClick={() => setActive("list")}
                      className={`view-toggle-item ${
                        active === "list" ? "active-item" : ""
                      }`}
                    >
                      {active === "list" ? (
                        <ListView style={iconStyle} />
                      ) : (
                        <SelectList style={iconStyle} />
                      )}
                    </div>

                    <div
                      onClick={() => setActive("grid")}
                      className={`view-toggle-item ${
                        active === "grid" ? "active-item" : ""
                      }`}
                    >
                      {active === "grid" ? (
                        <SelectGrid style={iconStyle} />
                      ) : (
                        <EmailView style={iconStyle} />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {active === "list" && (
              <div className="bg-white rounded-4 mt-3 w-100 p-3 custom-scrollbar-x">
                <div
                  style={{
                    display: "flex",
                    flex: "10",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    height: "44px",
                    backgroundColor: "#F2F2F2",
                    minWidth: "1200px",
                  }}
                  className="head3 w-100 justify-content-center align-items-center"
                >
                  {/* <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={handleChange}
                                style={{ marginRight: "8px", marginBottom: "14px" }}
                              /> */}
                  <p style={{ flex: "1.8", margin: "0px", whiteSpace: "nowrap" }} className="fs-13 fw-700 textcolor">
                    Code
                  </p>
                  <p style={{ flex: "1.2", margin: "0px", whiteSpace: "nowrap" }} className="fs-13 fw-700 textcolor">
                    PO
                  </p>
                  <p style={{ flex: "1.6", margin: "0px", whiteSpace: "nowrap" }} className="fs-13 fw-700 textcolor">
                    Vendor Name
                  </p>
                  <p style={{ flex: "1.1", margin: "0px", whiteSpace: "nowrap" }} className="fs-13 fw-700 textcolor">
                    Transaction Date
                  </p>
                  <p style={{ flex: "0.8", margin: "0px", whiteSpace: "nowrap" }} className="fs-13 fw-700 textcolor">
                    Total
                  </p>{" "}
                  <p style={{ flex: "0.8", margin: "0px", whiteSpace: "nowrap" }} className="fs-13 fw-700 textcolor">
                    Paid
                  </p>{" "}
                  <p style={{ flex: "0.8", margin: "0px", whiteSpace: "nowrap" }} className="fs-13 fw-700 textcolor">
                    Balance
                  </p>{" "}
                  <p style={{ flex: "1.3", margin: "0px", whiteSpace: "nowrap" }} className="fs-13 fw-700 textcolor">
                    Payment Type
                  </p>{" "}
                  <p style={{ flex: "1.4", margin: "0px", whiteSpace: "nowrap" }} className="fs-13 fw-700 textcolor">
                    Status
                  </p>{" "}
                  <p style={{ flex: "2.4", margin: "0px", whiteSpace: "nowrap" }} className="fs-13 fw-700 textcolor">
                    Next Approval
                  </p>{" "}
                </div>
                <div>
                  {(transactList ?? []).length === 0 ? (
                    <div className="text-center py-4 fs-14 text-muted fw-500 bg-white">
                      No Records Found
                    </div>
                  ) : (
                    (transactList ?? []).map((item, index) => (
                      <div
                      style={{
                        display: "flex",
                        flex: "10",
                        paddingLeft: "16px",
                        paddingRight: "16px",
                        backgroundColor: hoveredIndex === index ? "#FAFAFA" : "#FFFFFF",
                        borderBottom: "1px solid #D4DDE7",
                        cursor: "pointer",
                        height: "44px",
                        minWidth: "1200px",
                        position: "relative",
                      }}
                      onClick={() => {
                        if (checkPermission("Transactions", "view_permission")) {
                          navigate("/viewTransaction", {
                            state: { id: item.id },
                          });
                        }
                      }}
                      onMouseEnter={() => setHoveredIndex(index)}
                      onMouseLeave={() => setHoveredIndex(null)}
                      className="head3 w-100 justify-content-center align-items-center"
                    >
                      {" "}
                      {/* <input
                                    type="checkbox"
                                    checked={isChecked}
                                    onChange={handleChange}
                                    style={{ marginRight: "8px", marginBottom: "0px" }}
                                  /> */}
                      <p
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "1.8",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          margin: "0px",
                        }}
                        title={item.transaction_id}
                      >
                        {item.transaction_id ?? "---"}
                      </p>
                      <p
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "1.2",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          margin: "0px",
                        }}
                        title={item.po_no}
                      >
                        {item.po_no ?? "---"}
                      </p>
                      <p
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "1.6",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          margin: "0px",
                        }}
                        title={item.vendor_name}
                      >
                        <img
                          key={index}
                          src={item.image && item.image.trim() !== "" ? item.image : profileIc}
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedProfile(item.image && item.image.trim() !== "" ? item.image : profileIc);
                            setShowProfilePopup(true);
                          }}
                          alt="Profile"
                          className="avatar-item me-1 ms-0"
                        />
                        {item.vendor_name ?? "---"}
                      </p>
                      <p
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "1.1",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          margin: "0px",
                        }}
                        title={item.trans_date}
                      >
                        {item.trans_date ?? "---"}
                      </p>
                      <p
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "0.8",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          margin: "0px",
                        }}
                        title={item.total_amount}
                      >
                        <span dangerouslySetInnerHTML={{ __html: item.symbol || "&#8377;" }} /> {item.total_amount ?? "---"}
                      </p>
                      <p
                        className="fs-13 fw-500 cardTextBlue"
                        style={{
                          flex: "0.8",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          margin: "0px",
                        }}
                        title={item.paid_amount}
                      >
                        <span dangerouslySetInnerHTML={{ __html: item.symbol || "&#8377;" }} /> {item.paid_amount ?? "---"}
                      </p>
                      <p
                        className="fs-13 fw-500 cardTextRed"
                        style={{
                          flex: "0.8",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          margin: "0px",
                        }}
                        title={item.balance_amount}
                      >
                        <span dangerouslySetInnerHTML={{ __html: item.symbol || "&#8377;" }} /> {item.balance_amount ?? "---"}
                      </p>
                      {/* <p
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "1",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={item.status}
                      >
                        {item.status ?? "---"}
                      </p> */}
                      <div
                        style={{
                          flex: "1.3",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                        }}
                        className="d-flex align-items-center justify-content-start"
                      >
                        {" "}
                        <span className="d-flex align-items-center  gap-2">
                           <span className={`dropdown-text fs-13 fw-500 ${item.payment_type === "Cash" ? "cardTextGreen" : item.payment_type === "Credit" ? "cardTextRed" : item.payment_type === "Bank Transfer" ? "cardTextBlue" : "text-muted"}`}>{item.payment_type ?? "-"}</span>
                        </span>
                      </div>
                       <div
                        style={{
                          flex: "1.4",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                        }}
                        className="d-flex align-items-center justify-content-start"
                      >
                        {" "}
                        <span className="d-flex align-items-center  gap-2">
                          <span
                            className={
                              item.status === "Paid" || item.status === "Approved"
                                ? "backgroundGreen"
                                : item.status === "Pending" || item.status === "Rejected"
                                ? "backgroundRed"
                                : "backgroundYellow"
                            }
                            style={{
                              width: "10px",
                              height: "10px",
                              borderRadius: "3px",
                              display: "inline-block",
                            }}
                          ></span>

                          <span className="dropdown-text textcolor fs-13 fw-500">{item.status ?? "-"}</span>

                          <span className="dropdown-toggle-arrow">{/* <DownArrowIc /> */}</span>
                        </span>
                      </div>
                      <div
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "2.4",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          gap: "8px",
                          overflow: "visible",
                          minWidth: 0,
                        }}
                      >
                        {item.next_approver && item.next_approver !== "---" ? (
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "6px",
                              backgroundColor: "#F8F9FA",
                              borderRadius: "100px",
                              padding: "4px 12px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <LoadingIc style={{ width: "16px", height: "16px", flexShrink: 0 }} />
                            <span
                              className="text-truncate fs-13 fw-500"
                              style={{ 
                                maxWidth: (item.is_eligible && hoveredIndex === index) ? (item.can_reject ? "30px" : "55px") : "100px",
                                fontStyle: "italic",
                                color: "#1E293B"
                              }}
                              title={item.next_approver}
                            >
                              {item.next_approver}
                            </span>
                          </div>
                        ) : (
                          <span
                            className="text-truncate"
                            style={{ maxWidth: (item.is_eligible && hoveredIndex === index) ? (item.can_reject ? "30px" : "55px") : "100%" }}
                            title={item.next_approver}
                          >
                            {item.next_approver ?? "---"}
                          </span>
                        )}
                        {item.is_eligible && hoveredIndex === index && (
                          <>
                            <Button
                              variant="success"
                              className="rounded-5 fs-12 fw-600 py-0 px-2"
                              style={{
                                backgroundColor: "#10B981",
                                borderColor: "#10B981",
                                height: "28px",
                                lineHeight: "28px",
                                display: "inline-flex",
                                alignItems: "center",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleApprovalActionClick(item.id, "APPROVE", item.comments_mandatory);
                              }}
                            >
                              Approve
                            </Button>
                            {item.can_reject && (
                              <Button
                                variant="danger"
                                className="rounded-5 fs-12 fw-600 py-0 px-2 ms-1"
                                style={{
                                  backgroundColor: "#EF4444",
                                  borderColor: "#EF4444",
                                  height: "28px",
                                  lineHeight: "28px",
                                  display: "inline-flex",
                                  alignItems: "center",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleApprovalActionClick(item.id, "REJECT", true);
                                }}
                              >
                                Reject
                              </Button>
                            )}
                          </>
                        )}
                      </div>
                      {item.status === "Pending" && hoveredIndex === index && !item.is_eligible && (
                        <div
                          style={{
                            position: "absolute",
                            // top: "50%",
                            right: "35px",
                            // transform: "translate(-50%, -50%)",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "start",
                              alignItems: "center",
                            }}
                          >
                            {checkPermission("Transactions", "edit_permission") && (
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate("/transaction/create", {
                                    state: { id: item.id },
                                  });
                                }}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "28px",
                                  height: "28px",
                                  borderRadius: "100px",
                                  background: "#FFFFFF",
                                  cursor: "pointer",
                                  border: "0.8px solid #E5E5E5",
                                }}
                              >
                                <EditIc />{" "}
                              </div>
                            )}
                            <span style={{ marginLeft: "16px" }}></span>
                            {checkPermission("Transactions", "delete_permission") && (
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setDeleteId(item.id);
                                }}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "28px",
                                  height: "28px",
                                  borderRadius: "100px",
                                  background: "#FFFFFF",
                                  cursor: "pointer",
                                  border: "0.8px solid #E5E5E5",
                                }}
                              >
                                <DeleteIc />{" "}
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  )))}
                </div>
              </div>
            )}
            {active === "grid" && (
              transactList.length === 0 ? (
                <div className="bg-white rounded-4 mt-3 w-100 p-4 text-center fs-14 text-muted fw-500">
                  No Records Found
                </div>
              ) : (
                transactList.map((trans, index) => (
                  <div
                  key={index}
                  className="d-flex align-items-center justify-content-between flex-wrap business-card w-100 p-3 mt-3"
                  style={{ cursor: "pointer", height: "auto", minHeight: "84px" }}
                  onClick={() => {
                    if (checkPermission("Transactions", "view_permission")) {
                      navigate("/viewTransaction", {
                        state: { id: trans.id },
                      });
                    }
                  }}
                >
                  <div className="d-flex flex-grow-1" style={{ flex: "1 1 200px" }}>
                    <div className="profile-wrapper">
                      <img
                        src={trans.image && trans.image.trim() !== "" ? trans.image : profileIc}
                        alt="Profile"
                        className="profile-img"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedProfile(trans.image && trans.image.trim() !== "" ? trans.image : profileIc);
                          setShowProfilePopup(true);
                        }}
                      />
                      <div className="profile-badge fs-11">{trans.grade_name ?? "-"}</div>
                    </div>
                    <div className="d-flex flex-column gap-2 ps-3">
                      <div className="textcolor fs-16 fw-400 ">{trans.vendor_name ?? "-"}</div>
                      <div className="d-flex gap-2  align-items-center">
                        <span className="textGrey fs-12 fw-400">TD : {trans.transaction_id ?? "-"}</span>{" "}
                        <span
                          style={{
                            width: "4px",
                            height: "4px",
                            backgroundColor: "#D9D9D9",
                            borderRadius: "50%",
                            display: "inline-block",
                          }}
                        ></span>
                        <div className="rounded-4 backgroundBlue px-2 py-1 textBlue fs-11 fw-500">PO : {trans.po_no ?? "-"}</div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex flex-row gap-2 ps-3 flex-grow-1 align-items-center justify-content-center" style={{ flex: "1 1 400px" }}>
                    <div className="d-flex flex-column flex-grow-1 ">
                      <div className="fs-12 fw-500 cardTextGrey">Total :</div>
                      <div className="fs-15 fw-600 textcolor mt-1"> <span dangerouslySetInnerHTML={{ __html: trans.symbol || "&#8377;" }} /> {numberFormat(trans.total_amount ?? 0)}</div>
                    </div>
                    <div
                      style={{
                        height: "28px",
                        width: "1px",
                        backgroundColor: "#EBEBEB",
                      }}
                    ></div>
                    <div className="d-flex flex-column flex-grow-1 ">
                      <div className="fs-12 fw-500 cardTextGrey">Transaction Amount :</div>
                      <div className="fs-15 fw-600 cardTextGreen mt-1"><span dangerouslySetInnerHTML={{ __html: trans.symbol || "&#8377;" }} /> {numberFormat(trans.trans_amount ?? 0)}</div>
                    </div>
                    <div
                      style={{
                        height: "28px",
                        width: "1px",
                        backgroundColor: "#EBEBEB",
                      }}
                    ></div>
                    <div className="d-flex flex-column flex-grow-1 ">
                      <div className="fs-12 fw-500 cardTextGrey">Paid :</div>
                      <div className="fs-15 fw-600 cardTextBlue mt-1"> <span dangerouslySetInnerHTML={{ __html: trans.symbol || "&#8377;" }} /> {numberFormat(trans.paid_amount ?? 0)}</div>
                    </div>{" "}
                    <div
                      style={{
                        height: "28px",
                        width: "1px",
                        backgroundColor: "#EBEBEB",
                      }}
                    ></div>{" "}
                    <div className="d-flex flex-column flex-grow-1 ">
                      <div className="fs-12 fw-500 cardTextGrey">Balance :</div>
                      <div className="fs-15 fw-600 cardTextRed mt-1"> <span dangerouslySetInnerHTML={{ __html: trans.symbol || "&#8377;" }} /> {numberFormat(trans.balance_amount ?? 0)}</div>
                    </div>
                  </div>
                  <div className="d-flex flex-row flex-grow-1 align-items-center justify-content-end gap-2 ps-3" style={{ flex: "1.2 1 300px" }}>
                    {trans.next_approver && trans.next_approver !== "---" && (
                      <div
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "6px",
                          backgroundColor: "#F8F9FA",
                          borderRadius: "100px",
                          padding: "4px 12px",
                          whiteSpace: "nowrap",
                          height: "36px",
                        }}
                      >
                        <LoadingIc style={{ width: "16px", height: "16px", flexShrink: 0 }} />
                        <span
                          className="text-truncate fs-13 fw-500"
                          style={{ 
                            maxWidth: "200px",
                            fontStyle: "italic",
                            color: "#8790A1"
                          }}
                          title={trans.next_approver}
                        >
                          Waiting for <span style={{ color: "#1E293B", fontWeight: "600", fontStyle: "normal" }}>{trans.next_approver}</span> approval
                        </span>
                      </div>
                    )}
                    <div
                      style={{
                        padding: "6px 12px",
                        width: "125px",
                        backgroundColor:
                          trans.status === "Paid" || trans.status === "Approved"
                            ? "#E5FFF0"
                            : trans.status === "Pending" || trans.status === "Rejected"
                            ? "#FEE2E2"
                            : "#FFF5E2",
                      }}
                      className="d-flex align-items-center justify-content-center rounded-5"
                    >
                      <span className="d-flex align-items-center px-1 gap-2">
                        <span
                          className={
                            trans.status === "Paid" || trans.status === "Approved"
                              ? "backgroundGreen"
                              : trans.status === "Pending" || trans.status === "Rejected"
                              ? "backgroundRed"
                              : "backgroundYellow"
                          }
                          style={{
                            width: "10px",
                            height: "10px",
                            borderRadius: "3px",
                            display: "inline-block",
                          }}
                        ></span>

                        <span className="dropdown-text textcolor fs-13 fw-500">{trans.status ?? "-"}</span>

                        <span className="dropdown-toggle-arrow">{/* <DownArrowIc /> */}</span>
                      </span>
                    </div>

                    {(trans.status === "Pending" || trans.is_eligible) && (
                      <div onClick={(e) => e.stopPropagation()}>
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="light"
                            id="dropdown-sort"
                            className="d-flex align-items-center justify-content-between  rounded-5 bg-white"
                            style={{
                              width: "36px",
                              height: "36px",
                              border: "1px solid #EBEBEB",
                            }}
                          >
                            <span className="d-flex align-items-center px-1 gap-2">
                              <ThreeDotIC />
                            </span>
                          </Dropdown.Toggle>

                          <Dropdown.Menu
                            style={{
                              backgroundColor: "white",
                              borderRadius: "8px",
                              border: "1px solid #EBEBEB",
                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            }}
                          >
                            {trans.status === "Pending" && !trans.is_eligible && checkPermission("Transactions", "edit_permission") && (
                              <Dropdown.Item
                                className="fs-14 fw-500 textcolor"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate("/transaction/create", {
                                    state: { id: trans.id },
                                  });
                                }}
                              >
                                Edit
                              </Dropdown.Item>
                            )}
                            {trans.status === "Pending" && !trans.is_eligible && checkPermission("Transactions", "delete_permission") && (
                              <Dropdown.Item
                                className="fs-14 fw-500 textcolor"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setDeleteId(trans.id);
                                }}
                              >
                                Delete
                              </Dropdown.Item>
                            )}
                            {trans.is_eligible && (
                              <>
                                <Dropdown.Item
                                  className="fs-14 fw-500"
                                  style={{ color: "#10B981" }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleApprovalActionClick(trans.id, "APPROVE", trans.comments_mandatory);
                                  }}
                                >
                                  Approve
                                </Dropdown.Item>
                                {trans.can_reject && (
                                  <Dropdown.Item
                                    className="fs-14 fw-500 text-danger"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleApprovalActionClick(trans.id, "REJECT", true);
                                    }}
                                  >
                                    Reject
                                  </Dropdown.Item>
                                )}
                              </>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    )}
                    {trans.status !== "Pending" && !trans.is_eligible && (
                      <div style={{ width: "36px", height: "36px" }}></div>
                    )}
                  </div>
                </div>
              ))))
            }
            <div className="py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
              <Dropdown>
                <span className="pagination-color">Records per page: &nbsp;</span>
                <Dropdown.Toggle id="dropdown-basic" className="bg-transparent pagination-color  border-0 custom-dropdown-toggle p-0">
                  <span className="bg-white textcolor no-of-rows rounded-3 px-2 py-2">
                    {itemsPerPage} <DownArrowIc />
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="my-2" style={{ minWidth: "unset", width: "30%" }}>
                  {[10, 25, 50, 75, 100].map((size) => (
                    <Dropdown.Item
                      key={size}
                      onClick={() => {
                        setItemsPerPage(size);
                        setItemOffset(0);
                      }}
                      active={itemsPerPage === size}
                      className="text-center"
                    >
                      {size}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <div className="d-flex align-items-center gap-2">
                <ReactPaginate
                  previousLabel={
                    <div
                      className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                      style={{
                        width: "32px",
                        height: "32px",
                      }}
                    >
                      <LarIc />
                    </div>
                  }
                  nextLabel={
                    <div
                      className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                      style={{
                        width: "32px",
                        height: "32px",
                      }}
                    >
                      <RarIc />
                    </div>
                  }
                  breakLabel={"..."}
                  pageCount={pageCount + 1}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  forcePage={itemOffset}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={showApprovalModal}
        onHide={() => setShowApprovalModal(false)}
        centered
        className="custom-modal"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fs-18 fw-600 textcolor">
            {approvalAction === "REJECT" ? "Reject Transaction" : "Approve Transaction"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-3">
          <Form.Group>
            <Form.Label className="fs-14 fw-500 textcolor mb-2">
              {approvalAction === "REJECT" 
                ? "Enter reason for rejection" 
                : "Enter comments"
              }
              {approvalCommentsMandatory && <span className="text-danger"> *</span>}
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={approvalComments}
              onChange={(e) => setApprovalComments(e.target.value)}
              placeholder="Type comments here..."
              className="fs-13 rounded-3"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0">
          <Button
            variant="light"
            onClick={() => setShowApprovalModal(false)}
            className="rounded-3 px-3 py-1_5 fs-13 fw-500"
          >
            Cancel
          </Button>
          <Button
            variant={approvalAction === "REJECT" ? "danger" : "primary"}
            onClick={handleApprovalAction}
            className="rounded-3 px-3 py-1_5 fs-13 fw-600"
            disabled={approvalCommentsMandatory && !approvalComments.trim()}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
}

export default TransactionListingPage;
